import { loadRecommendationsEvents, loadRecommendationsOverviews } from '@common/redux/slices/recommendation.slice';
import { useLocaleFilter } from "@common/hooks/useLocaleFilter";
import { reduxWrapper } from '@common/redux/store';
import { loadEntitiesFromQuery } from '@kursk/utils/loadEntitiesFromQuery';
import React from 'react';
import { TouristRoutes } from "@kursk/components/pages/TouristRoutes/TouristRoutes";
import { loadDurations } from "@common/redux/slices/touristroutes.slice";
import { checkLocales } from "@common/utils/locales";

export default function RoutesPage() {
  useLocaleFilter();

  return <TouristRoutes/>;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query, res, req, ...data }) => {
  const checkResult = await checkLocales(data['resolvedUrl'], query, req, res, store);
  if (checkResult) return checkResult;

  await Promise.all([
    loadEntitiesFromQuery('touristroutes', query, store),
    store.dispatch(loadRecommendationsEvents({ locales: query.locales })),
    store.dispatch(loadRecommendationsOverviews({})),
    store.dispatch(loadDurations({})),
  ]);

  return { props: {} };
})
